import React, {Component} from "react";
import queryString from "query-string";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {Button, Col, Input, Progress, Row, Spin, Tooltip, Typography} from "antd";
import Popover from "@mui/material/Popover";
import {bloodClass, componentIds, DisplaySettingType, MorphleLogoBW, MorphleLogoSquare} from "../utils/const";
import BloodSummary from "./bloodsummary";
import BloodGraph from "./bloodgraphview";
import {bloodClassChanged} from "../redux_actions/bloodGrid.action";
import {
	resetWBC,
	resetZStackWBC,
	updateAllGridsWBC,
	updateDifferentialConfirmStatus,
	updatePageWBCView,
	wbcGridSelected,
} from "../redux_actions/wbcview.action";
import {fieldGridSelected, reset, resetZStack, updatePageFieldView,} from "../redux_actions/fieldView.action";
import FieldGridView from "./fieldegridview";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {FaSortAmountDown, FaSortAmountUp} from "react-icons/fa";
import {CheckOutlined, EditOutlined, FundViewOutlined, LoadingOutlined,} from "@ant-design/icons";
import "antd/dist/antd.css";
import "../asset/style/workflow/tab-pane.css";
import "../asset/style/bloodviewer/blood_viewer.css";
import {
	rbcGridSelected,
	updateFetchingGridRBC,
	updatePageRBCView,
	updateSelectedGridOverallId,
} from "../redux_actions/bloodGridRBC.action";
import {
	pltGridSelected,
	updateFetchingGridPLT,
	updatePagePLT,
	updateSelectedGridOverallIdPLT,
} from "../redux_actions/bloodGridPLT.action";
import {calculateClientHeightRatio, debounce, isTrue, notNull, openEndPoint} from "../utils/utils";
import AnnotationsPaginatedGrid from "../component/gammaviewer/components/AnnotationsPaginatedGrid";
import Slidemap from "../component/gammaviewer/Slidemap";
import {Brightness6, SettingsBrightness} from "@mui/icons-material";
import BloodGridView from "./bloodgridviewgeneric";
import DisplaySettings from "../component/gammaviewer/sidebarTop_apps/DisplaySettings";
import {updateSlide} from "../redux_actions/maps.state.action";
import {pollForStitchingStatus} from "../utils/slide_utils";
import {store} from "../helper/store";
import {locateAnnotationOnMap, resetAnnotationStyle} from "../component/gammaviewer/utils/map_utils";
import {markAnnotation} from "../component/gammaviewer/utils/annotations_app_utils";
import ZoomControl from "../component/gammaviewer/rightBottom_apps/zoomControl";
import Field100xView from "../component/gammaviewer/components/Field100xView";
import {get_response} from "../helper/request";
import cookie from "react-cookies";

// const {TabPane} = Tabs;
const {Text} = Typography;


export class BloodScan extends Component {
	constructor(props) {
		super(props);

		this.fieldRef = React.createRef();

		this.state = {
			stitching_done: true,
			stitch_percent: 0.0,
			stitch_time: 0.0,
			scan_ongoing: false,
			isFetching: true,
			errorCount: 0,
			blood_class: bloodClass.FIELD,
			navigate: false,
			selected_anno: "",
			view_mode: 1,
			slide_name: this.props.slide.name,
			currZStackIndex: "",
			differential: this.props.slide?.differential,
			nameEditable: false,
			slide_data: "",
			size_asc: true,
			uneven_asc: false,
			elongation_asc: false,
			plt_size_asc: true,
			mean_color_asc: false,
			settingsAnchorEl: null,
		};

		this.max_txty_time = 0;
		this.timer = null;
		document.addEventListener("keydown", this.pressArrows);
	}

	pressArrows = (event) => {
		if (!event.shiftKey) {
			switch (event.keyCode) {
				case 39:
					this.loadNext(0);
					break;
				case 37:
					this.loadPrev(0);
					break;
				case 38:
					this.loadPrev(1);
					break;
				case 40:
					this.loadNext(1);
					break;
				default:
					break;
			}
		}
	}

	resizeListener = () => {
		this.forceUpdate()
	}

	componentDidMount = () => {
		this.timer = setInterval(() => pollForStitchingStatus(this.props.slide.id, this.timer, this.max_txty_time,
			obj => this.setState(obj), obj => {
				this.timer = obj.timer;
				this.max_txty_time = obj.max_txty_time
			}), 2000);
		this.debounceFunc = debounce(this.resizeListener, 400)
		window.addEventListener("resize", this.debounceFunc);
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.wbcGridData.tag !== this.props.wbcGridData.tag) {
			// this.props.dispatch(resetWBC());
			this.props.dispatch(resetZStackWBC());
			this.props.dispatch(updateAllGridsWBC([]));
			this.props.dispatch(updateDifferentialConfirmStatus(true));
		}
	};

	componentWillUnmount = () => {
		document.removeEventListener("keydown", this.pressArrows);
		clearInterval(this.timer);
		this.timer = null;

		window.removeEventListener("resize", this.debounceFunc);
	};

	onTabChange = (key) => {
		switch (key) {
			default:
			case 0:
				if (this.state.blood_class === bloodClass.FIELD) {
					return;
				}
				this.props.dispatch(reset);
				this.props.dispatch(resetZStackWBC());
				this.setState({
					blood_class: bloodClass.FIELD,
				});
				break;
			case 1:
				if (this.state.blood_class === bloodClass.WBC) {
					return;
				}
				this.setState({
					blood_class: bloodClass.WBC,
				});
				this.props.dispatch(reset());
				this.props.dispatch(resetZStack());
				this.props.dispatch(bloodClassChanged(bloodClass.WBC));
				break;
			case 2:
				if (this.state.blood_class === bloodClass.RBC) {
					return;
				}
				this.props.dispatch(resetWBC());
				this.props.dispatch(resetZStackWBC());
				this.props.dispatch(reset());
				this.props.dispatch(resetZStack());
				this.setState({
					blood_class: bloodClass.RBC,
				});
				break;
			case 3:
				if (this.state.blood_class === bloodClass.PLT) {
					return;
				}
				this.props.dispatch(resetWBC());
				this.props.dispatch(resetZStackWBC());
				this.setState({
					blood_class: bloodClass.PLT,
				});
				break;
		}
	};

	onTabChangeNonDiff = (key) => {
		if (key === 0) {
			if (this.state.blood_class === bloodClass.WBC) {
				return;
			}
			this.setState({
				blood_class: bloodClass.WBC,
			});
			this.props.dispatch(reset());
			this.props.dispatch(resetZStack());
			this.props.dispatch(bloodClassChanged(bloodClass.WBC));
		} else if (key === 1) {
			if (this.state.blood_class === bloodClass.FIELD) {
				return;
			}
			this.props.dispatch(resetWBC());
			this.props.dispatch(resetZStackWBC());
			this.setState({
				blood_class: bloodClass.FIELD,
			});
		}
	};

	calcNewCount = (shiftColumn, rowLength, currCount, isNext) => {
		let sign = 1;
		let pageSize = this.props.wbcGridData.page_size;
		if (!isNext) {
			sign = -1;
		}
		let newCount;
		if (shiftColumn) {
			let end = false;
			if (isNext) {
				let temp = currCount % pageSize;
				if (temp === 0 || (temp < pageSize && temp > pageSize - rowLength)) {
					end = true;
				}
			} else {
				let temp = currCount % pageSize;
				if (temp >= 1 && temp <= rowLength) {
					end = true;
				}
			}
			if (!end) {
				newCount = currCount + sign * rowLength;
			} else {
				newCount = currCount;
			}
		} else {
			newCount = currCount + sign;
		}
		return newCount;
	};

	load = (grid) => {
		let anno_id = grid["id"];
		let slide_id = this.props.slide.id;
		if (this.state.blood_class === bloodClass.FIELD) {
			let page_size = this.props.fieldGridData.page_size;
			let url = `/api/get_selected_field_anno_page/?anno_id=${anno_id}&slide_id=${slide_id}&page_size=${page_size}`;
			get_response(url).then((res) => {
				this.props.dispatch(updatePageFieldView(res.data["page"]));
				this.props.dispatch(fieldGridSelected(grid));
			});
			this.selectAnnotationOnMap(this.annotations.find(annotation => annotation.id === anno_id));
		} else if (this.state.blood_class === bloodClass.WBC) {
			let page_size = this.props.wbcGridData.page_size;
			let page = Math.ceil(grid.count / page_size);
			this.props.dispatch(updatePageWBCView(page));
			this.props.dispatch(wbcGridSelected(grid));
			this.selectAnnotationOnMap(this.annotations.find(annotation => annotation.id === anno_id));
		}
	};

	loadNext = (shiftColumn) => {
		let currCount;
		let newCount;
		let all_grids;
		let rowLength =
			this.state.blood_class === bloodClass.RBC ||
			this.state.blood_class === bloodClass.PLT
				? 8
				: 3;
		if (this.state.blood_class === bloodClass.FIELD) {
			currCount = this.props.fieldGridData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 1);
			all_grids = this.props.fieldGridData.all_grids;
		} else if (this.state.blood_class === bloodClass.WBC) {
			currCount = this.props.wbcGridData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 1);
			all_grids = this.props.wbcGridData.all_grids;
		} else if (this.state.blood_class === bloodClass.RBC) {
			let curr_grids = this.props.bloodGridRBCData.curr_grids;
			currCount = this.props.bloodGridRBCData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 1);
			let found = false;
			for (let i = 0; i < curr_grids.length; i++) {
				if (parseInt(curr_grids[i].overall_count) === newCount) {
					this.props.dispatch(rbcGridSelected(curr_grids[i]));
					found = true;
				}
			}
			if (
				!found &&
				newCount < this.props.bloodGridRBCData.total_count &&
				this.props.bloodGridRBCData.page <
				this.props.bloodGridRBCData.total_pages &&
				!this.props.bloodGridRBCData.fetching_grid
			) {
				let page_size = this.props.bloodGridRBCData.page_size;
				let newPage = Math.ceil((currCount + 1) / page_size);
				this.props.dispatch(updateSelectedGridOverallId(newCount));
				this.props.dispatch(updatePageRBCView(newPage));
				this.props.dispatch(updateFetchingGridRBC(true));
			}
			return;
		} else if (this.state.blood_class === bloodClass.PLT) {
			let curr_grids = this.props.bloodGridPLTData.curr_grids;
			currCount = this.props.bloodGridPLTData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 1);
			let found = false;
			for (let i = 0; i < curr_grids.length; i++) {
				if (parseInt(curr_grids[i].overall_count) === newCount) {
					this.props.dispatch(pltGridSelected(curr_grids[i]));
					found = true;
				}
			}
			if (
				!found &&
				newCount < this.props.bloodGridPLTData.total_count &&
				this.props.bloodGridPLTData.page <
				this.props.bloodGridPLTData.total_pages &&
				!this.props.bloodGridPLTData.fetching_grid
			) {
				let page_size = this.props.bloodGridPLTData.page_size;
				let newPage = Math.ceil((currCount + 1) / page_size);
				this.props.dispatch(updateSelectedGridOverallIdPLT(newCount));
				this.props.dispatch(updatePagePLT(newPage));
				this.props.dispatch(updateFetchingGridPLT(true));
			}
			return;
		}

		if (newCount <= all_grids.length) {
			this.load(all_grids[newCount - 1]);
		}
	};

	loadPrev = (shiftColumn) => {
		let currCount;
		let newCount;
		let all_grids;
		let rowLength =
			this.state.blood_class === bloodClass.RBC ||
			this.state.blood_class === bloodClass.PLT
				? 8
				: 3;
		if (this.state.blood_class === bloodClass.FIELD) {
			currCount = this.props.fieldGridData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 0);
			all_grids = this.props.fieldGridData.all_grids;
		} else if (this.state.blood_class === bloodClass.WBC) {
			currCount = this.props.wbcGridData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 0);
			all_grids = this.props.wbcGridData.all_grids;
		} else if (this.state.blood_class === bloodClass.RBC) {
			let curr_grids = this.props.bloodGridRBCData.curr_grids;
			currCount = this.props.bloodGridRBCData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 0);
			let found = false;
			for (let i = 0; i < curr_grids.length; i++) {
				if (parseInt(curr_grids[i].overall_count) === newCount) {
					this.props.dispatch(rbcGridSelected(curr_grids[i]));
					found = true;
				}
			}
			if (
				!found &&
				newCount >= 1 &&
				this.props.bloodGridRBCData.page > 1 &&
				!this.props.bloodGridRBCData.fetching_grid
			) {
				let page_size = this.props.bloodGridRBCData.page_size;
				let newPage = Math.ceil((currCount - 1) / page_size);
				this.props.dispatch(updateSelectedGridOverallId(newCount));
				this.props.dispatch(updatePageRBCView(newPage));
				this.props.dispatch(updateFetchingGridRBC(true));
			}
			return;
		} else if (this.state.blood_class === bloodClass.PLT) {
			let curr_grids = this.props.bloodGridPLTData.curr_grids;
			currCount = this.props.bloodGridPLTData.selected_grid.overall_count;
			newCount = this.calcNewCount(shiftColumn, rowLength, currCount, 0);
			let found = false;
			for (let i = 0; i < curr_grids.length; i++) {
				if (parseInt(curr_grids[i].overall_count) === newCount) {
					this.props.dispatch(pltGridSelected(curr_grids[i]));
					found = true;
				}
			}
			if (
				!found &&
				newCount >= 1 &&
				this.props.bloodGridPLTData.page > 1 &&
				!this.props.bloodGridPLTData.fetching_grid
			) {
				let page_size = this.props.bloodGridPLTData.page_size;
				let newPage = Math.ceil((currCount - 1) / page_size);
				this.props.dispatch(updateSelectedGridOverallIdPLT(newCount));
				this.props.dispatch(updatePagePLT(newPage));
				this.props.dispatch(updateFetchingGridPLT(true));
			}
			return;
		}

		if (newCount > 0) {
			this.load(all_grids[newCount - 1]);
		}
	};

	onTabChangeWBCTabs = (index) => {
		if (index === 0) {
			this.props.dispatch(updateDifferentialConfirmStatus(true));
		} else {
			this.props.dispatch(updateDifferentialConfirmStatus(false));
		}
	};

	setName = (val) => {
		this.setState({slide_name: val});
	};

	selectAnnotationOnMap = (annotation) => {
		resetAnnotationStyle();
		markAnnotation(this.props.activeMapId, annotation);
		locateAnnotationOnMap(this.props.slidemap, annotation, true);
	}

	getBloodSettingsComponent = () => {
		return <Tooltip title={"High Power Display Settings"} placement={"right"}>
			<Button
				onClick={e => this.setState({
					bloodSettingsAnchorEl: e.currentTarget,
				})}
				style={{
					backgroundColor: "rgba(0,0,0,0)",
					borderColor: "rgba(0,0,0,0)",
					position: "absolute",
					left: "0px",
					bottom: "50px",
					width: "60px",
					color: "white",
					padding: 0,
					height: "40px",
				}}
			>
				<Brightness6 style={{fontSize: "24px"}}/>
			</Button>
		</Tooltip>
	};

	getBloodSettingsMenu = () => {
		let open = Boolean(this.state.bloodSettingsAnchorEl);
		if (!open) return null;
		return (
			<Popover
				open={open}
				anchorEl={this.state.bloodSettingsAnchorEl}
				onClose={() => this.setState({
					bloodSettingsAnchorEl: null,
				})}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div
					style={{
						backgroundColor: "#548fa1",
						width: "350px",
						height: "350px",
						padding: "15px",
					}}
				>
					<DisplaySettings type={DisplaySettingType.FIELD}/>
				</div>
			</Popover>
		);
	};

	getGammaSettingsComponent = () => {
		return <Tooltip title={"Low Power Display Settings"} placement={"right"}>
			<Button
				onClick={e => this.setState({
					settingsAnchorEl: e.currentTarget,
				})}
				style={{
					backgroundColor: "rgba(0,0,0,0)",
					borderColor: "rgba(0,0,0,0)",
					position: "absolute",
					left: "0px",
					bottom: "100px",
					width: "60px",
					color: "white",
					padding: 0,
					height: "40px",
				}}
			>
				<SettingsBrightness style={{fontSize: "24px"}}/>
			</Button>
		</Tooltip>

	};

	getGammaSettingsMenu = () => {
		let open = Boolean(this.state.settingsAnchorEl);
		if (!open) return null;
		return (
			<Popover
				open={open}
				anchorEl={this.state.settingsAnchorEl}
				onClose={() => this.setState({
					settingsAnchorEl: null,
				})}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div
					style={{
						backgroundColor: "#548fa1",
						width: "350px",
						height: "700px",
						padding: "15px",
					}}
				>
					<DisplaySettings type={DisplaySettingType.SLIDE}/>
				</div>
			</Popover>
		);
	};

	getGammaLink = () => {
		return <Tooltip title={"Go to WSI viewer"} placement={"right"}>
			<Button
				onClick={() => openEndPoint(`/gamma/${this.props.slide.id}?#?bloodMapEnable=true`, true, true)}
				style={{
					backgroundColor: "rgba(0,0,0,0)",
					borderColor: "rgba(0,0,0,0)",
					position: "absolute",
					left: "0px",
					bottom: "1px",
					width: "60px",
					color: "white",
					padding: 0,
					height: "40px",
				}}
			>
				<FundViewOutlined style={{fontSize: "24px"}}/>
			</Button>
		</Tooltip>
	}

	getSortIcon = (isAsc) => {
		if (isAsc) {
			return <FaSortAmountUp style={{fontSize: "18px", color: "#00F548"}}/>;
		}
		return <FaSortAmountDown style={{fontSize: "18px", color: "#00F548"}}/>;
	};

	onClickSort = (stateToBeChanged, val) => {
		this.setState({
			[stateToBeChanged]: val,
		});
	};

	getHeader = () => {
		let nameComponent;
		if (!this.state.nameEditable) {
			nameComponent = (
				<div className={'full-parent flex-center'}>
					<Text className={'full-height'}
					      code style={{color: 'cyan', fontSize: '25px', overflow: 'hidden'}}>
						<b>{this.state.slide_name}</b>
					</Text>
					<Tooltip title="Edit Name">
						<Button
							className={'full-height'}
							onClick={() => {
								this.setState({nameEditable: true});
							}}
							style={{
								backgroundColor: "rgba(0,0,0,0)",
								borderColor: "rgba(0,0,0,0)",
							}}
						>
							<EditOutlined
								style={{color: "rgba(255,255,255,0.3)", fontSize: "20px"}}
							/>
						</Button>
					</Tooltip>
				</div>
			);
		} else {
			nameComponent = (
				<div className={'full-parent'}
				     style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px'}}>
					<Input
						autoFocus
						code
						onChange={(e) => this.setName(e.target.value)}
						value={this.state.slide_name}
						bordered={false}
						onPressEnter={() => {
							this.setState({nameEditable: false});
							store.dispatch(updateSlide(this.props.activeMapId, this.props.slide.id, {
								name: this.state.slide_name,
							}))
						}}
						className={'full-height'}
						style={{
							textAlign: "center",
							fontSize: "22px",
							width: "50%",
							minWidth: '300px',
							backgroundColor: "rgb(3, 17, 44)",
							borderColor: "white",
							color: "white",
						}}
					/>
					<Button
						className={'full-height'}
						style={{
							backgroundColor: "rgba(0,0,0,0)",
							borderColor: "rgba(0,0,0,0)",
						}}
						onClick={() => {
							this.setState({nameEditable: false});
							store.dispatch(updateSlide(this.props.activeMapId, this.props.slide.id, {
								name: this.state.slide_name,
							}))
						}}
					>
						<CheckOutlined style={{color: "#00FF00", fontSize: "20px"}}/>
					</Button>
				</div>
			);
		}

		return (
			<Row
				className={'full-parent'}
				style={{
					textAlign: "center",
					backgroundColor: "#0b1c3b",
					height: "4.3%",
					minHeight: '40px',
				}}
			>
				<Col className={'full-height'} xs={{span: 2}} lg={{span: 3}} style={{textAlign: "left"}}>
					<Link to={"/dashboard"} className={'full-height'}
					      style={{display: 'flex', padding: 5}}>
						<img
							src={document.documentElement.clientWidth > 990 ? MorphleLogoBW : MorphleLogoSquare}
							alt={"logo"}
							style={{maxHeight: '40px'}}
						></img>
					</Link>
				</Col>
				<Col className={'full-height'} xs={{span: 20}} lg={{span: 18}}>
					{nameComponent}
				</Col>
				<Col className={'full-height'} xs={{span: 2}} lg={{span: 3}} style={{textAlign: "right"}}></Col>
			</Row>
		);
	};

	getNonDifferentialView = () => {

		return (

			<Tabs
				onSelect={(index) => {
					this.onTabChangeNonDiff(index);
				}}
			>
				<TabList>
					<Tab>
						<p>WBC</p>
					</Tab>
					<Tab>
						<p>FLD</p>
					</Tab>
				</TabList>

				<TabPanel
					style={this.state.blood_class === bloodClass.WBC ? {width: "100%"} : {}}
				>
					<Col
						span={6}
					>
						<FieldGridView
							slide_id={this.props.slide.id}
							dispatch={this.props.dispatch}
							view_mode={this.state.view_mode}
							selected={this.props.wbcGridData.selected_grid}
							page={this.props.wbcGridData.page}
							fieldGridData={this.props.fieldGridData}
							mode={bloodClass.WBC}
							wbcGridData={this.props.wbcGridData}
							cssfilter={this.props.fieldDisplaySetting}
						/>
					</Col>
					<Col
						span={18}
						style={{paddingTop: "0.5vh"}}
					>
						<Field100xView
							annotation={this.props.wbcGridData.selected_grid}
							annotations={this.props.wbcGridData.all_grids} row={2} col={1}
							cssfilter={this.props.fieldDisplaySetting}
							onSelect={this.selectAnnotationOnMap}
							scale={this.props.scale}
							mode={bloodClass.WBC}
							loadNext={this.loadNext}
							loadPrev={this.loadPrev}
						/>
					</Col>
				</TabPanel>
				<TabPanel
					style={this.state.blood_class === bloodClass.FIELD ? {width: "100%"} : {}}
				>
					<Col
						style={{marginTop: "-0.5vh"}}
						span={this.state.view_mode === 1 ? 6 : 7}
					>
						<FieldGridView
							slide_id={this.props.slide.id}
							dispatch={this.props.dispatch}
							view_mode={this.state.view_mode}
							selected={this.props.fieldGridData.selected_grid}
							page={this.props.fieldGridData.page}
							fieldGridData={this.props.fieldGridData}
							mode={bloodClass.FIELD}
							cssfilter={this.props.fieldDisplaySetting}
						/>
					</Col>
					<Col
						style={{paddingTop: "0.5vh"}}
						span={18}
					>
						<Field100xView
							annotation={this.props.wbcGridData.selected_grid}
							annotations={this.props.wbcGridData.all_grids} row={2} col={1}
							cssfilter={this.props.fieldDisplaySetting}
							onSelect={this.selectAnnotationOnMap}
							scale={this.props.scale}
							mode={bloodClass.WBC}
							loadNext={this.loadNext}
							loadPrev={this.loadPrev}
						/>
					</Col>
				</TabPanel>
			</Tabs>
		);
	};

	getSlideMap = () => {
		let desiredHeight = calculateClientHeightRatio(1, this.fieldRef.current?.offsetHeight)

		return <Slidemap
			{...this.props.mapState}
			field_view={true}
			mode={this.state.blood_class}
			height={desiredHeight}
			fieldGridData={this.props.fieldGridData}
			wbcGridData={this.props.wbcGridData}
			pltGridData={this.props.pltGridData}
			rbcGridData={this.props.bloodGridRBCData}
			bloodGridData={this.props.bloodGridData}
			bloodMapEnable={true}
		/>;
	}

	getDifferentialView = () => {
		let antIcon = (
			<LoadingOutlined
				style={{fontSize: 50, marginTop: "19vh", marginLeft: "-1.3vw"}}
				spin
			/>
		);

		return (

			<Tabs className={'full-parent'} style={{display: 'flex'}} onSelect={index => this.onTabChange(index)}>
				<TabList>
					<Tab>FLD</Tab>
					<Tab>WBC</Tab>
					<Tab>RBC</Tab>
					<Tab>PLT</Tab>
				</TabList>

				<TabPanel style={this.state.blood_class === bloodClass.FIELD ? {
					width: '10%',
					flexGrow: 1,
					height: '100%'
				} : {}}>
					{/*flexGrow makes it use all available space*/}
					<AnnotationsPaginatedGrid annotations={this.fieldAnnotations} row={2} col={1}
											  cssfilter={this.props.fieldDisplaySetting}
											  markedAnnotation={(this.props.annotationState || {}).markedAnnotation}
											  onSelect={this.selectAnnotationOnMap} scale={this.props.scale}
					/>
				</TabPanel>

				<TabPanel style={this.state.blood_class === bloodClass.WBC ? {
					width: '10%',
					flexGrow: 1,
					height: '100%'
				} : {}}>
					<Col className={'full-height'}
					     span={5}>
						<BloodSummary class={bloodClass.WBC} slide_id={this.props.slide.id}
									  wbcGridData={this.props.wbcGridData} dispatch={this.props.dispatch}
									  update_list={this.props.bloodGridData.update_list}
									  tag={this.props.wbcGridData.tag}/>
					</Col>
					<Col className={'full-height'}
					     span={6}>
						{this.props.wbcGridData.tag === "" ?
							<BloodGridView
								slide_id={this.props.slide.id}
								selected={this.props.wbcGridData.selected_grid}
								page={this.props.wbcGridData.page}
								mode={bloodClass.WBC}
								orderby="id" confused={false}
								cssfilter={this.props.fieldDisplaySetting}
								onSelect={this.selectAnnotationOnMap}
								loadNext={this.loadNext}
								loadPrev={this.loadPrev}
							/> :
							<Tabs id="tab-horizontal" className={"full-parent"}
								  selectedIndex={this.props.wbcGridData.differential_confirmed ? 0 : 1}
								  onSelect={index => this.onTabChangeWBCTabs(index)}>
								<TabList>
									<Tab>Confident</Tab>
									<Tab>Confusion</Tab>
								</TabList>
								<TabPanel>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.wbcGridData.selected_grid}
										page={this.props.wbcGridData.page}
										mode={bloodClass.WBC}
										orderby="id" confused={false}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
										loadNext={this.loadNext}
										loadPrev={this.loadPrev}
									/>
								</TabPanel>
								<TabPanel>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.wbcGridData.selected_grid}
										page={this.props.wbcGridData.page}
										mode={bloodClass.WBC}
										orderby="id" confused={true}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
										loadNext={this.loadNext}
										loadPrev={this.loadPrev}
									/>
								</TabPanel>
							</Tabs>}
					</Col>
					<Col
						className={'full-height'}
						span={13}
					>
						<Field100xView
							annotation={this.props.wbcGridData.selected_grid}
							annotations={this.props.wbcGridData.all_grids} row={2} col={1}
							cssfilter={this.props.fieldDisplaySetting}
							onSelect={this.selectAnnotationOnMap}
							scale={this.props.scale}
							mode={bloodClass.WBC}
							loadNext={this.loadNext}
							loadPrev={this.loadPrev}
						/>
					</Col>
				</TabPanel>
				<TabPanel style={this.state.blood_class === bloodClass.RBC ? {
					width: '10%',
					flexGrow: 1,
					height: '100%'
				} : {}}>
					<Col
						className={"full-height"}
						span={6}
					>
						<BloodGraph
							key={"RBC_GRAPH"}
							class={bloodClass.RBC}
							slide_id={this.props.slide.id}
							dispatch={this.props.dispatch}
							fieldGridData={this.props.fieldGridData}
							data={this.props.bloodGridRBCData}
						/>
					</Col>

					<Col
						className={"full-height"}
						span={18}
					>
						<Spin
							indicator={antIcon}
							key="loading"
							wrapperClassName={'full-parent'}
							spinning={this.props.bloodGridRBCData.fetching_grid}
						>
							<Tabs
								id="tab-horizontal"
								className={"full-parent"}
							>
								<TabList>
									<Tab>
										<Row className={"full-parent flex-center"}>
											<Col className={"flex-center"} span={24}>
												<Text className={'full-height'}
												      style={{color: 'inherit'}}>
													Unordered
												</Text>
											</Col>
										</Row>
									</Tab>
									<Tab>
										<Row className={"full-parent flex-center"}>
											<Col className={"flex-center"} span={20}>
												<Text className={'full-height'}
												      style={{color: 'inherit'}}>
													Size
												</Text>
											</Col>
											<Tooltip
												placement="top"
												title={
													this.state.size_asc
														? "Sorted by Ascending"
														: "Sorted by Descending"
												}
												key={this.state.size_asc}
											>
												<Col
													span={4}
													onClick={() =>
														this.onClickSort(
															"size_asc",
															!this.state.size_asc
														)
													}
												>
													{this.getSortIcon(this.state.size_asc)}
												</Col>
											</Tooltip>
										</Row>
									</Tab>
									<Tab>
										<Row className={"full-parent flex-center"}>
											<Col className={"flex-center"} span={20}>
												<Text className={'full-height'}
												      style={{color: 'inherit'}}>
													Elongation
												</Text>
											</Col>
											<Tooltip
												placement="top"
												title={
													this.state.elongation_asc
														? "Sorted by Ascending"
														: "Sorted by Descending"
												}
												key={this.state.elongation_asc}
											>
												<Col
													span={4}
													onClick={() =>
														this.onClickSort(
															"elongation_asc",
															!this.state.elongation_asc
														)
													}
												>
													{this.getSortIcon(this.state.elongation_asc)}
												</Col>
											</Tooltip>
										</Row>
									</Tab>
									<Tab>
										<Row className={"full-parent flex-center"}>
											<Col className={"flex-center"} span={20}>
												<Text className={'full-height'}
												      style={{color: 'inherit'}}>
													Unevenness
												</Text>
											</Col>
											<Tooltip
												placement="top"
												title={
													this.state.uneven_asc
														? "Sorted by Ascending"
														: "Sorted by Descending"
												}
												key={this.state.uneven_asc}
											>
												<Col
													span={4}
													onClick={() =>
														this.onClickSort(
															"uneven_asc",
															!this.state.uneven_asc
														)
													}
												>
													{this.getSortIcon(this.state.uneven_asc)}
												</Col>
											</Tooltip>
										</Row>
									</Tab>
									{this.props.bloodGridRBCData
										.extreme_mean_color_range_low !== 0 &&
									this.props.bloodGridRBCData
										.extreme_mean_color_range_high !== 0 ? (
										<Tab>
											<Row className={"full-parent flex-center"}>
												<Col className={"flex-center"} span={20}>
													<Text className={'full-height'}
													      style={{color: 'inherit'}}>
														Pallor
													</Text>
												</Col>
												<Tooltip
													placement="top"
													title={
														this.state.mean_color_asc
															? "Sorted by Ascending"
															: "Sorted by Descending"
													}
													key={this.state.mean_color_asc}
												>
													<Col
														span={4}
														onClick={() =>
															this.onClickSort(
																"mean_color_asc",
																!this.state.mean_color_asc
															)
														}
													>
														{this.getSortIcon(this.state.mean_color_asc)}
													</Col>
												</Tooltip>
											</Row>
										</Tab>
									) : null}
								</TabList>
								<TabPanel key="unordered">
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.bloodGridRBCData.selected_grid}
										page={this.props.bloodGridRBCData.page}
										mode={bloodClass.RBC}
										orderby="id" confused={false}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
									/>
								</TabPanel>
								<TabPanel key={this.state.size_asc ? "asc-s" : "desc-s"}>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.bloodGridRBCData.selected_grid}
										page={this.props.bloodGridRBCData.page}
										mode={bloodClass.RBC}
										orderby={`${this.state.size_asc ? "" : "-"}size`}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
									/>
								</TabPanel>
								<TabPanel key={this.state.elongation_asc ? "asc-e" : "desc-e"}>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.bloodGridRBCData.selected_grid}
										page={this.props.bloodGridRBCData.page}
										mode={bloodClass.RBC}
										orderby={`${this.state.elongation_asc ? "" : "-"}eccentricity`}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
									/>
								</TabPanel>
								<TabPanel key={this.state.uneven_asc ? "asc-c" : "desc-c"}>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.bloodGridRBCData.selected_grid}
										page={this.props.bloodGridRBCData.page}
										mode={bloodClass.RBC}
										orderby={`${this.state.uneven_asc ? "" : "-"}convexity`}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
									/>
								</TabPanel>
								{this.props.bloodGridRBCData.extreme_mean_color_range_low !==
								0 &&
								this.props.bloodGridRBCData.extreme_mean_color_range_high !==
								0 ? (
									<TabPanel key={this.state.mean_color_asc ? "asc-m" : "desc-m"}>
										<BloodGridView
											slide_id={this.props.slide.id}
											selected={this.props.bloodGridRBCData.selected_grid}
											page={this.props.bloodGridRBCData.page}
											mode={bloodClass.RBC}
											orderby={`${this.state.mean_color_asc ? "" : "-"}mean_color`}
											cssfilter={this.props.fieldDisplaySetting}
											onSelect={this.selectAnnotationOnMap}
										/>
									</TabPanel>
								) : null}
							</Tabs>
						</Spin>
					</Col>
				</TabPanel>

				<TabPanel
					style={this.state.blood_class === bloodClass.PLT ? {width: '10%', flexGrow: 1, height: '100%'} : {}}
				>
					<Col
						className={"full-height"}
						span={6}
					>
						<BloodGraph
							key={"PLT_GRAPH"}
							class={bloodClass.PLT}
							slide_id={this.props.slide.id}
							dispatch={this.props.dispatch}
							data={this.props.bloodGridPLTData}
						/>
					</Col>
					<Col
						className={"full-height"}
						span={18}
					>
						<Spin
							indicator={antIcon}
							key="loading"
							wrapperClassName={'full-parent'}
							spinning={this.props.bloodGridPLTData.fetching_grid}
						>
							<Tabs
								id="tab-horizontal"
								className={"full-parent"}
							>
								<TabList>
									<Tab>
										<Row className={"full-parent flex-center"}>
											<Col className={"flex-center"} span={24}>
												<Text className={'full-height'}
												      style={{color: 'inherit'}}>
													Unordered
												</Text>
											</Col>
										</Row>
									</Tab>
									<Tab>
										<Row className={"full-parent flex-center"}>
											<Col className={"flex-center"} span={20}>
												<Text className={'full-height'}
												      style={{color: 'inherit'}}>
													Size
												</Text>
											</Col>
											<Tooltip
												placement="top"
												title={
													this.state.plt_size_asc
														? "Sorted by Ascending"
														: "Sorted by Descending"
												}
												key={this.state.plt_size_asc}
											>
												<Col
													span={4}
													onClick={() =>
														this.onClickSort(
															"plt_size_asc",
															!this.state.plt_size_asc
														)
													}
												>
													{this.getSortIcon(this.state.plt_size_asc)}
												</Col>
											</Tooltip>
										</Row>
									</Tab>
								</TabList>
								<TabPanel>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.bloodGridPLTData.selected_grid}
										page={this.props.bloodGridPLTData.page}
										mode={bloodClass.PLT}
										orderby={"id"}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
									/>
								</TabPanel>
								<TabPanel key={this.state.plt_size_asc ? "asc-p-s" : "desc-p-s"}>
									<BloodGridView
										slide_id={this.props.slide.id}
										selected={this.props.bloodGridPLTData.selected_grid}
										page={this.props.bloodGridPLTData.page}
										mode={bloodClass.PLT}
										orderby={`${this.state.plt_size_asc ? "" : "-"}size`}
										cssfilter={this.props.fieldDisplaySetting}
										onSelect={this.selectAnnotationOnMap}
									/>
								</TabPanel>


							</Tabs>
						</Spin>
					</Col>
				</TabPanel>
			</Tabs>
		);
	};

	getResults = () => {
		let differential = this.state.differential;

		let stitchingInProgressComponent = (
			<Row key="progress">
				<Row style={{textAlign: "center"}}>
					<h2>Stitching in Progress</h2>
					<Progress
						style={{marginTop: "1%", marginBottom: "1%"}}
						type="circle"
						percent={parseFloat(this.state.stitch_percent)}
					/>
					<Link to={"/dashboard"}>
						<h2>Click to go back to Dashboard</h2>
					</Link>
				</Row>
			</Row>
		);

		let scanOngoingComponent = (
			<Row>
				<Row style={{textAlign: "center", marginTop: "5em"}}>
					<b>
						Slide is being scanned. <br></br>Progress will be updated soon.
					</b>
					<Link
						to={"/dashboard"}
						className="click-to-go-to-dash"
					>
						<h2>Click to go back to Dashboard</h2>
					</Link>
				</Row>
			</Row>
		);

		let viewerComponent;

		if (
			!this.state.scan_ongoing &&
			this.state.stitching_done &&
			!this.state.isFetching
		) {
			const text = document.documentElement.clientWidth > 1100 ? "Area Scan @ 40x" :
				<Tooltip title={"Area Scan @ 40x"} placement={"top"}>40X</Tooltip>
			viewerComponent = (
				<div className={'full-parent'}>
					<div ref={this.fieldRef}
					     className={'full-parent'}
					     style={{height: "95%", maxHeight: window.innerHeight - 80}}>
						{this.getSlideMap()}
					</div>
					{this.state.view_mode === 1 ? (
						<div
							className={'full-parent'}
							style={{height: "5%", minHeight: 40}}>
							<Row className={'full-parent'}>
								<Text keyboard
								      className={'full-height flex-center'}
								      style={{color: 'white', fontSize: '22px', overflow: 'hidden'}}>{text}</Text>
							</Row>
						</div>
					) : null}
				</div>
			);
		}

		if ((this.props.slide || {}).specimen_type === undefined)
			return null;
		return <div key="view" className={'full-parent'}>
			<Spin key="loading" tip="Loading..." spinning={this.state.isFetching} delay={500}
			      wrapperClassName={'full-parent'}>
				{this.state.scan_ongoing === true ? scanOngoingComponent : this.state.stitching_done === true ?
					<div className={'full-parent'}>
						{this.getHeader()}
						<Row className={'full-parent'}
						     style={{backgroundColor: "#03112c", height: '95.7%', maxHeight: window.innerHeight - 40}}>
							{differential ?
								[<Col
									className={'full-height'}
									span={this.state.blood_class === bloodClass.FIELD ? document.documentElement.clientWidth > 1000 ? 8 : 12 : 20}>
									{this.getDifferentialView()}
								</Col>,
									<Col
										className="viewer-component full-height"
										span={this.state.blood_class === bloodClass.FIELD ? document.documentElement.clientWidth > 1000 ? 16 : 12 : 4}
										id={"viewer-id"} style={{backgroundColor: "#03112c"}}>
										{viewerComponent}
									</Col>] :
								[<Col span={16}>
									{this.getNonDifferentialView()}
								</Col>,
									<Col class="viewer-component" id={"viewer-id"}
									     style={{backgroundColor: "#03112c"}}
									     span={8}>
										{viewerComponent}
									</Col>]}
						</Row>
					</div> : stitchingInProgressComponent}
			</Spin>
		</div>;
	}
	render() {
		let oldAnnotations = this.annotations;
		this.annotations = (this.props.annotationState || {}).annotations;
		if (notNull(this.annotations) && oldAnnotations !== this.annotations) {
			this.fieldAnnotations = this.annotations.filter(annotation => annotation.anno_drawer === 4)
				.sort((annotation1, annotation2) => annotation1.id - annotation2.id);
		} else {
			this.fieldAnnotations = this.props.fieldGridData.all_grids;
		}
		let results = this.getResults();

		let displaySettings = window.innerHeight > 400;

		let settingsComponent = displaySettings ? this.getBloodSettingsComponent() : null;
		let settingsMenu = displaySettings ? this.getBloodSettingsMenu() : null;

		let gammaLink = displaySettings ? this.getGammaLink() : null;
		let gammaSettingsComponent = displaySettings ? this.getGammaSettingsComponent() : null;

		let gammaSettingsMenu = displaySettings ? this.getGammaSettingsMenu() : null;

		let rightBottom = <ZoomControl/>;

		document.title = `${this.props.mapState.slide.name}`;

		return (
			<div className={"full-parent"}>
				{results}

				{}
				{settingsComponent}
				{settingsMenu}
				{gammaSettingsComponent}
				{gammaSettingsMenu}
				{gammaLink}
				<div id={componentIds.rightBottomApps}
					 style={{position: 'absolute', bottom: 55, right: '25px', zIndex: 2}}>
					{rightBottom}
				</div>
				{this.props.notifications && this.props.notifications[0]}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	let mapState = state.mapsStateReducer[ownProps.activeMapId];
	let {slide, fieldDisplaySetting, displaySetting, annotationState} = mapState;
	let gammaState = state.gammaStateReducer;
	let {notifications, activeMapId, scale} = gammaState;
	return {
		bloodGridData: state.bloodGridReducer,
		bloodGridRBCData: state.bloodGridRBCReducer,
		bloodGridPLTData: state.bloodGridPLTReducer,
		fieldGridData: state.fieldViewReducer,
		wbcGridData: state.wbcViewReducer,
		pltGridData: state.bloodGridPLTReducer,
		slide,
		mapState,
		activeMapId,
		displaySetting,
		fieldDisplaySetting,
		annotationState,
		notifications,
		scale,
		gammaState
	};
};

export default connect(mapStateToProps)(BloodScan);
